import update from 'immutability-helper';
import { A, fetchGetTicketSameOrder } from '../actions/tickets';

const initialState = {
  unreadedCount: 0,
  topics: [],

  newTicket: {
    isFetching: false,
    error: null,
  },

  getTickets: {
    isFetching: false,
    error: null,
  },

  getTicketThread: {
    isFetching: false,
    error: null,
  },

  getTicketSameOrder: {
    isFetching: false,
    error: null,
  },

  postMessage: {
    isFetching: false,
    error: null,
  },

  postRate: {
    isFetching: false,
    error: null,
  },

  registerUser: {
    isFetching: false,
    error: null,
  },

  setUnreadedStatus: {
    isFetching: false,
    error: null,
  },

  getUnreadedCount: {
    isFetching: false,
    error: null,
  },

  getTopics: {
    isFetching: false,
    error: null,
  },

  exportTickets: {
    isFetching: false,
    error: null,
  },
};

const tickets = (state = initialState, action) => {
  switch (action.type) {
    case A.FETCH_NEW_TICKET_REQUEST:
      return update(state, {
        newTicket: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_NEW_TICKET_SUCCESS:
      return update(state, {
        newTicket: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_NEW_TICKET_FAILURE:
      return update(state, {
        newTicket: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_GET_TICKETS_REQUEST:
      return update(state, {
        getTickets: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_GET_TICKETS_SUCCESS:
      return update(state, {
        getTickets: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_GET_TICKETS_FAILURE:
      return update(state, {
        getTickets: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_GET_TICKET_THREAD_REQUEST:
      return update(state, {
        getTicketThread: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_GET_TICKET_THREAD_SUCCESS:
      return update(state, {
        getTicketThread: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_GET_TICKET_THREAD_FAILURE:
      return update(state, {
        getTicketThread: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_GET_TICKET_SAME_ORDER_REQUEST:
      return update(state, {
        getTicketSameOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_GET_TICKET_SAME_ORDER_SUCCESS:
      return update(state, {
        getTicketSameOrder: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_GET_TICKET_SAME_ORDER_FAILURE:
      return update(state, {
        getTicketSameOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_POST_MESSAGE_REQUEST:
      return update(state, {
        postMessage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_POST_MESSAGE_SUCCESS:
      return update(state, {
        postMessage: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_POST_MESSAGE_FAILURE:
      return update(state, {
        postMessage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_POST_RATE_REQUEST:
      return update(state, {
        postRate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_POST_RATE_SUCCESS:
      return update(state, {
        postRate: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_POST_RATE_FAILURE:
      return update(state, {
        postRate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_REGISTER_USER_REQUEST:
      return update(state, {
        registerUser: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_REGISTER_USER_SUCCESS:
      return update(state, {
        registerUser: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_REGISTER_USER_FAILURE:
      return update(state, {
        registerUser: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_SET_UNREADED_STATUS_REQUEST:
      return update(state, {
        setUnreadedStatus: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_SET_UNREADED_STATUS_SUCCESS:
      return update(state, {
        setUnreadedStatus: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_SET_UNREADED_STATUS_FAILURE:
      return update(state, {
        setUnreadedStatus: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_GET_UNREADED_COUNT_REQUEST:
      return update(state, {
        getUnreadedCount: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.SET_UNREADED_TICKET_COUNT:
      return update(state, {
        getUnreadedCount: {
          isFetching: { $set: false },
          error: { $set: null },
        },
        unreadedCount: { $set: action.unreadedCount },
      });

    case A.FETCH_GET_UNREADED_COUNT_FAILURE:
      return update(state, {
        getUnreadedCount: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_GET_TOPICS_REQUEST:
      return update(state, {
        getTopics: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.SET_TOPICS:
      return update(state, {
        getTopics: {
          isFetching: { $set: false },
          error: { $set: null },
        },
        topics: { $set: action.topics },
      });

    case A.FETCH_GET_TOPICS_FAILURE:
      return update(state, {
        getTopics: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_EXPORT_TICKET_REQUEST:
      return update(state, {
        exportTickets: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.FETCH_EXPORT_TICKET_SUCCESS:
      return update(state, {
        exportTickets: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.FETCH_EXPORT_TICKET_FAILURE:
      return update(state, {
        exportTickets: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default tickets;
